import { render, staticRenderFns } from "./TicketsCategoriesContainer.vue?vue&type=template&id=0ff3ebc1&scoped=true"
import script from "./TicketsCategoriesContainer.vue?vue&type=script&lang=js"
export * from "./TicketsCategoriesContainer.vue?vue&type=script&lang=js"
import style0 from "./TicketsCategoriesContainer.vue?vue&type=style&index=0&id=0ff3ebc1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff3ebc1",
  null
  
)

export default component.exports